export default __webpack_public_path__ + "media/Seasoning.806beeab.png";